import React, { useState } from "react";
import { ReactComponent as IconCloseCircle } from "../../../build/images/platformnps/closecircle.svg";
import Button from "../Button";
import MicroModal from "micromodal";
import axios from "axios";
import { connection_platform } from "../../../services/api";
import { useSelector } from "react-redux";

// let url_connection = `${connection_platform.type_connect}:${localStorage.getItem("pathname")}:${localStorage.getItem("port")}`
// let url_connection = `https://cloud.ingweb.com.br:8080`
let port = localStorage.getItem("port");
let url_connection = `${connection_platform.type_connect}://${connection_platform.ip_intern}:${port}`;

const AcceptEvaluationModal = ({
  modalTitle,
  treatmentData,
  data,
  infoTreatment,
  getlistDeal,
  handleTableDataLookup,
  searchData,
  page,
  setPage,
  rowsPerPage,
}) => {
  const userReducer = useSelector((state) => state.informationusers);

  const closeModal = () => {
    MicroModal.close("modal-component-accept-evaluation-modal");
  };

  const saveQuestionEvaluation = async () => {
    if (infoTreatment.id_deal_status !== null) {
      MicroModal.close("modal-component-accept-evaluation-modal");
      await axios.get(
        `${url_connection}/conn/update-deal?idatendimento=${
          data.id_atendimento
        }&user_response=${userReducer.id}&id_deal_status=${4}&cdrid=${
          data.id_cdr
        }&changed_profile=false&closed=true`
      );
    } else {
      MicroModal.close("modal-component-accept-evaluation-modal");
      await axios.get(
        `${url_connection}/conn/insert-deal?idatendimento=${
          data.id_atendimento
        }&user_response=${userReducer.id}&id_deal_status=${4}&cdrid=${
          data.id_cdr
        }&changed_profile=falsee&closed=true`
      );
    }
    const previousPage = page;
    const filteredTreatmentData = await getlistDeal();
    const filteredData = handleTableDataLookup(
      searchData,
      filteredTreatmentData
    );
    const hasFilteredData =
      !!filteredData && Array.isArray(filteredData) && filteredData.length > 0;

    if (!hasFilteredData) {
      setPage(0);
    }

    if (hasFilteredData) {
      const totalOfItems = filteredData.length;
      const maxOfPages =
        parseInt(totalOfItems / rowsPerPage) +
        (totalOfItems % rowsPerPage !== 0 ? 1 : 0);
      const isPreviousPageBiggerThanMaxOfPages = previousPage + 1 > maxOfPages;
      if (isPreviousPageBiggerThanMaxOfPages) {
        setPage(maxOfPages - 1);
      } else {
        setPage(previousPage);
      }
    }
  };

  function formatPhoneNumber(phoneNumber) {
    if (!phoneNumber) return "";

    const ddd = phoneNumber.substring(0, 2);
    const number = phoneNumber.substring(2);

    return `(${ddd}) ${number}`;
  }

  return (
    <div
      className="modal micromodal-slide"
      id="modal-component-accept-evaluation-modal"
      aria-hidden="true"
    >
      <div className={`modal__overlay`} aria-modal="true" tabIndex="-1">
        <div
          className="modal__container"
          role="dialog"
          style={{ padding: "24px", borderRadius: "8px" }}
        >
          <div className="modal-component__general-accept">
            <div className="modal-component__general__header">
              <span>{modalTitle}</span>
              <div className="modal_close" onClick={() => closeModal()}>
                <IconCloseCircle />
              </div>
            </div>
            <div className="modal-component__general__body">
              <div className="modal-component__general__body-title">
                <span>
                  Ao aceitar, você confirma que a resposta foi tratada.
                </span>
              </div>
              <div className="modal-component__general__body-contents">
                <div>
                  Cliente:
                  <span> {treatmentData.nome_cliente}</span>
                </div>
                <div>
                  Perfil:
                  <span
                    className={
                      treatmentData.nota_nps >= 1 && treatmentData.nota_nps <= 6
                        ? "Detrator"
                        : treatmentData.nota_nps === 7 ||
                          treatmentData.nota_nps === 8
                        ? "Neutro"
                        : "Promotor"
                    }
                  >
                    {treatmentData.nota_nps >= 1 && treatmentData.nota_nps <= 6
                      ? " Detrator"
                      : treatmentData.nota_nps === 7 ||
                        treatmentData.nota_nps === 8
                      ? " Neutro"
                      : " Promotor"}
                  </span>
                </div>
                <div>
                  Nota:
                  <span
                    className={
                      treatmentData.nota_nps >= 1 && treatmentData.nota_nps <= 6
                        ? "Detrator"
                        : treatmentData.nota_nps === 7 ||
                          treatmentData.nota_nps === 8
                        ? "Neutro"
                        : "Promotor"
                    }
                  >
                    {" " + treatmentData.nota_nps}
                  </span>
                </div>
                <div>
                  Atendimento:
                  <span> {treatmentData.id_atendimento}</span>
                </div>
                <div>
                  Unidade:
                  <span> {treatmentData.empresa}</span>
                </div>
                <div>
                  Data e hora:
                  <span> {treatmentData.data_atendimento}</span>
                </div>
                <div>
                  Telefone:
                  <span>
                    {" "}
                    {formatPhoneNumber(treatmentData.numero_cliente)}
                  </span>
                </div>
              </div>
            </div>
            <div className="modal-component__general__body-actions">
              <Button
                label="Cancelar"
                theme="danger"
                action={() => closeModal()}
              />
              <Button
                label="Salvar"
                theme="primary"
                action={() => saveQuestionEvaluation()}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AcceptEvaluationModal;
